import drawSoccerJersey from './utils/draw-soccer-jersey';
const draw = drawSoccerJersey;
export { draw };
